'use client';

import { FC, PropsWithChildren, createContext, useContext } from 'react';
import { LocationContext } from './types';

const locationContext = createContext<LocationContext>({
  featureFlags: {
    PCC_ECTDealerLocationFlag: false
  }
});

export const useLocationCtx = () => useContext(locationContext);

export const LocationProvider: FC<
  PropsWithChildren<{ value: LocationContext }>
> = ({ children, value }) => (
  <locationContext.Provider value={value}>{children}</locationContext.Provider>
);
